import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.audits.systemlog.data = {
      ...state.developer.audits.systemlog.data,
      ...data,
    };
  });
};

const info = async (store, id) => {
  store.setState((state) => {
    state.developer.audits.systemlog.busy = true;
  });

  try {
    const data = { ...store.state.developer.audits.systemlog.data };

    const response = await Http.get(`/app/audits/system-logs/${id}`, data);

    store.setState((state) => {
      state.developer.audits.systemlog.busy = false;
      state.developer.audits.systemlog.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.audits.systemlog.busy = false;
      state.developer.audits.systemlog.data = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.audits.systemlog = { ...initialState };
  });
};

const SystemLogInfoStore = {
  state: () => initialState,
  actions: {
    change,
    info,
    reset,
  },
};

export default SystemLogInfoStore;
